/**
 * KeyboardDismissToolbar - web stub
 *
 * iOS InputAccessoryView + react-native-keyboard-controller are native-only.
 * This file must not import that package: webpack aliases it to `false`, and a
 * static import in a shared .tsx white-screens itssecure (Cannot find module).
 */

import React from 'react';

export const ACCESSORY_VIEW_ID = 'keyboard-dismiss';

export type KeyboardDismissToolbarProps = {
  nativeID?: string;
};

export const KeyboardDismissToolbar: React.FC<
  KeyboardDismissToolbarProps
> = () => null;
